import { createContext, useEffect, useReducer } from "react";

import http from "src/services/httpService";
//import axios from "../utils/axios";
//import { isValidToken, setSession } from "../utils/jwt";
import { isValidToken, setSession } from "../utils/oAuthUtility";

const INITIALIZE = "INITIALIZE";
const SIGN_IN = "SIGN_IN";
const SIGN_OUT = "SIGN_OUT";
//const SIGN_UP = "SIGN_UP";// Keep For Madd

const initialState = {
  isAuthenticated: false,
  isInitialized: false,
  user: null,
};

const oAuthReducer = (state, action) => {
  switch (action.type) {
    case INITIALIZE:
      return {
        isAuthenticated: action.payload.isAuthenticated,
        isInitialized: true,
        user: action.payload.user,
      };
    case SIGN_IN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
      };
    case SIGN_OUT:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
      };

    // case SIGN_UP:// Keep For Madd
    //   return {
    //     ...state,
    //     isAuthenticated: true,
    //     user: action.payload.user,
    //   };

    default:
      return state;
  }
};

const AuthContext = createContext(null);

function AuthProvider({ children }) {
  //useState can do the same work as useReducer but useReducer is better for global state ...
  const [state, dispatch] = useReducer(oAuthReducer, initialState);

  useEffect(() => {
    const initialize = async () => {
      try {
        const accessToken = window.localStorage.getItem(http.tokenKey);
        if (accessToken && isValidToken(accessToken)) {
          setSession(accessToken);
          // TODO :>  Check if hit when refresh or navigate between pages
          //         1 - get user info
          //         2- get user menu
          // const response = await axios.get("/api/auth/my-account");
          // const { user } = response.data;
          const user = { name: "Abubakr test" };
          // console.log(user);

          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: true,
              user,
            },
          });
        } else {
          dispatch({
            type: INITIALIZE,
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      } catch (err) {
        console.error(err);
        dispatch({
          type: INITIALIZE,
          payload: {
            isAuthenticated: false,
            user: null,
          },
        });
      }
    };

    initialize();
  }, []);

  const signIn = async (userName, password) => {
    const qs = require("qs");
    const data = qs.stringify({
      //username,
      userName,
      password,
      grant_type: "password",
    });
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const apiUrl = http.getApiURL().replace("/api", "");
    const { data: token } = await http.post(apiUrl + "/token", data, config);
    // localStorage.setItem(tokenKey, token.access_token);
    // http.setAccessToken(getBearerToken());
    const user = { userName: "Abubakr Kamal" }; //TODO load user info from DB
    setSession(token.access_token);
    dispatch({
      type: SIGN_IN,
      payload: {
        user,
      },
    });
  };

  /* For .NetCore MVCC
    const signIn = async (userName, password) => {
    const qs = require("qs");
    const data = qs.stringify({
      //username,
      userName,
      password,
      grant_type: "password",
    });
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };

    const apiUrl = http.getApiURL().replace("/api", "");
												

    const { data: token } = await http.post(apiUrl + "/token", data, config);
    // localStorage.setItem(tokenKey, token.access_token);
    // http.setAccessToken(getBearerToken());
    const user = { userName: "Abubakr Kamal" }; //TODO load user info from DB
    setSession(token.access_token);
    dispatch({
      type: SIGN_IN,
      payload: {
        user,
      },
    });
  };
  */

  // const signInOld = async (userName, password) => {
  //   const response = await axios.post("/api/auth/sign-in", {
  //     userName,
  //     password,
  //   });
  //   const { accessToken, user } = response.data;

  //   setSession(accessToken);
  //   dispatch({
  //     type: SIGN_IN,
  //     payload: {
  //       user,
  //     },
  //   });
  // };

  const signOut = async () => {
    setSession(null);
    dispatch({ type: SIGN_OUT });
  };

  /*// Keep For Madd
   const signUp = async (email, password, firstName, lastName) => {
    const response = await axios.post("/api/auth/sign-up", {
      email,
      password,
      firstName,
      lastName,
    });
    const { accessToken, user } = response.data;

    window.localStorage.setItem("accessToken", accessToken);
    dispatch({
      type: SIGN_UP,
      payload: {
        user,
      },
    });
  };
*/
  const resetPassword = (email) => console.log(email);

  return (
    <AuthContext.Provider
      value={{
        ...state,
        //method: "jwt",
        method: "oAuth",
        signIn,
        signOut,
        // signUp,// Keep For Madd
        resetPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthContext, AuthProvider };
